import { CEEntityAttributesBase } from './ce-entity-attributes-base'


export class CEEntityAttributes extends CEEntityAttributesBase {

}